export default Object.freeze({
	HOST_CLICK: 'szn.discussion.to.embed.hostClick',
	BOUNDING_RECT_CHANGE: 'szn.discussion.to.embed.boundingRectChange',
	SCROLL_DONE: 'szn.discussion.to.embed.scrollCompleted',
	HANDSHAKE_OK: 'szn.discussion.to.embed.handshakeOk',
	CONFIRMED: 'szn.discussion.to.embed.confirmed',
	SHARED: 'szn.discussion.to.embed.shared',
	MODAL_CLOSED: 'szn.discussion.to.embed.modalClosed',
	LOGIN: 'szn.discussion.to.embed.login',
	LOGOUT: 'szn.discussion.to.embed.logout',
	OAUTH_FAIL: 'szn.discussion.to.embed.oauthFailed',
	LOGIN_FAIL: 'szn.discussion.to.embed.loginFailed',
	LOGIN_CLOSE: 'szn.discussion.to.embed.loginClose',
	NO_TOKEN_TO_SEND: 'szn.discussion.to.embed.noTokenToSend',
	ADD_COMMENT_BUTTON_CLICKED: 'szn.discussion.to.embed.addCommentButtonClicked',
	POST_COMMENT: 'szn.discussion.to.embed.postComment',
	WIDGET_FORM_CLOSE: 'szn.discussion.to.embed.widgetFormClose'
});
